<template>
  <PrintPageLandscape>
    <PresentationPage :page-number="pageNumber" :page-count="pageCount">
      <p class="presentation-page__eyebrow">Kernkompetenzen · Übersicht</p>

      <h2 class="presentation-page__title">
        Fünf Kompetenzen — eine durchgängige Wertschöpfungskette
      </h2>

      <p class="presentation-page__text">
        Von der ersten Beratung bis zum 20-Jahre-Betrieb decken wir alle Phasen mit eigenen Teams
        ab.
      </p>

      <div class="presentation-page__group-cards presentation-page__group-cards--five">
        <article
          v-for="competency in competencies"
          :key="competency.number"
          class="presentation-page__group-card"
        >
          <div
            class="presentation-page__group-card-body presentation-page__group-card-body--competency"
          >
            <div
              :class="[
                'presentation-page__group-card-step',
                `presentation-page__group-card-step--${competency.accent}`,
              ]"
            >
              {{ competency.number }}
            </div>

            <div
              :class="[
                'presentation-page__group-card-icon',
                `presentation-page__group-card-icon--${competency.accent}`,
              ]"
              aria-hidden="true"
            >
              <i :class="['fa', competency.icon]"></i>
            </div>

            <h3 class="presentation-page__group-card-title">{{ competency.title }}</h3>

            <div class="presentation-page__group-card-accent" aria-hidden="true"></div>

            <p class="presentation-page__group-card-text">{{ competency.text }}</p>
          </div>
        </article>
      </div>

      <p class="presentation-page__caption">
        Alle Kompetenzen unter einem Dach · 20+ Jahre Erfahrung · 6.000+ realisierte Projekte
      </p>
    </PresentationPage>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationPage from '@/views/MasterPresentation/PresentationPage';

export default {
  name: 'MasterPresentationPrintPage15',

  components: {
    PrintPageLandscape,
    PresentationPage,
  },

  props: {
    project: { type: Object, default: null },
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },

  data() {
    return {
      competencies: [
        {
          number: 1,
          accent: 'brand-primary',
          icon: 'fa-user',
          title: 'Beratung',
          text: 'Bedarfsanalyse, Standort- und Ertragsprognose, Wirtschaftlichkeit.',
        },
        {
          number: 2,
          accent: 'brand-primary',
          icon: 'fa-pencil-square-o',
          title: 'Planung',
          text: 'Technische Auslegung, Statik, Netzverträglichkeit, Genehmigung.',
        },
        {
          number: 3,
          accent: 'brand-teal',
          icon: 'fa-wrench',
          title: 'Installation',
          text: 'Eigene Montageteams, DC- und AC-Komplettmontage bis HS-Ebene.',
        },
        {
          number: 4,
          accent: 'brand-primary',
          icon: 'fa-shield',
          title: 'Qualität & Sicherheit',
          text: '4-Augen-Prüfung, lückenlose Dokumentation, Live-Abnahmen.',
        },
        {
          number: 5,
          accent: 'brand-primary',
          icon: 'fa-cloud',
          title: 'Digitale Prozesse',
          text: 'RETIS-Plattform: End-to-End-Digitalisierung & Reporting.',
        },
      ],
    };
  },
};
</script>
